// src/utils/api.js
const PROD_DEFAULT = 'https://golf-den-server.onrender.com';
const DEV_DEFAULT  = 'http://127.0.0.1:5000';

const raw = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? PROD_DEFAULT : DEV_DEFAULT);

// strip trailing slashes just in case
export const API_BASE = (raw || '').replace(/\/+$/, '');

// console.log("[api] NODE_ENV:", process.env.NODE_ENV);
// console.log("[api] REACT_APP_API_URL:", process.env.REACT_APP_API_URL);
// console.log("[api] API_BASE:", API_BASE);